import React from 'react'

import s from './styles.module.scss'

import { HouseEquipment, IHouseEquipment } from '../../../../molecules'

interface ProposalHouseEquipmentsProps {
  equipments: (IHouseEquipment & {
    _id: string
  })[]
}
export const ProposalHouseEquipments = ({
  equipments,
}: ProposalHouseEquipmentsProps) => {
  return (
    <>
      <div className={s.list}>
        {equipments.map((equipment, index) => (
          <HouseEquipment
            key={equipment._id}
            equipment={equipment}
            withSeparator={equipments.length > 1 && index > 0}
          />
        ))}
      </div>
    </>
  )
}
